module.exports = __webpack_public_path__ + "static/media/Krungthep-01.3ec107b1.svg";